// import components
import BacklogEntityTypeToggle from '../BacklogEntityTypeToggle';
import BacklogFilters from '../BacklogFilters';

// import hooks
import { useIsVerticalToolbar } from 'components/shared/ToolbarSet/ToolbarPosition.context';

// import styles
import { LeadingControlsRow } from './BacklogToolbarLeadingControls.styles';

// import types
import type { BacklogToolbarLeadingControlsProps } from './BacklogToolbarLeadingControls.types';

/**
 * The left end of the toolbar: the filters that narrow the list, then the symbols for which planning
 * entity's takenlijst is shown. Both read as "what am I looking at", so they sit together before the
 * date picker, with the filter icon on the outside edge.
 *
 * One component rather than two slot entries so the two rows share a container and can turn onto the
 * vertical axis together, which is what makes a side-docked toolbar stack the five icons rather than
 * running them out of its width. Each reads that layout from the toolbar's own context, so neither has
 * to be handed it.
 */
const BacklogToolbarLeadingControls = ({
  rowEntityType,
  onRowEntityTypeChange,
  ...filterProps
}: BacklogToolbarLeadingControlsProps) => {
  const isVerticalToolbar = useIsVerticalToolbar();

  return (
    <LeadingControlsRow isVertical={isVerticalToolbar}>
      <BacklogFilters {...filterProps} rowEntityType={rowEntityType} />
      <BacklogEntityTypeToggle
        activeType={rowEntityType}
        onChange={onRowEntityTypeChange}
        isVertical={isVerticalToolbar}
      />
    </LeadingControlsRow>
  );
};

export default BacklogToolbarLeadingControls;
